(function () {
  function initSlider(root) {
    var track = root.querySelector('[data-mc-track]');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.children);
    var prev = root.querySelector('[data-mc-prev]');
    var next = root.querySelector('[data-mc-next]');
    var dots = root.querySelector('[data-mc-dots]');
    var current = 0;

    function visibleCount() {
      if (window.innerWidth <= 640) return 1;
      if (window.innerWidth <= 1100) return 2;
      return root.dataset.sliderType === 'reviews' ? 4 : 4;
    }

    function maxIndex() {
      return Math.max(cards.length - visibleCount(), 0);
    }

    function goTo(index) {
      current = Math.max(0, Math.min(index, maxIndex()));
      if (cards[current]) {
        track.scrollTo({ left: cards[current].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      updateDots();
    }

    function buildDots() {
      if (!dots) return;
      dots.innerHTML = '';
      var total = maxIndex() + 1;
      for (var i = 0; i < total; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mc-slider-dot' + (i === current ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (index) { btn.addEventListener('click', function () { goTo(index); }); })(i);
        dots.appendChild(btn);
      }
    }

    function updateDots() {
      if (!dots) return;
      Array.prototype.forEach.call(dots.querySelectorAll('.mc-slider-dot'), function (dot, index) {
        dot.classList.toggle('is-active', index === current);
      });
    }

    if (prev) prev.addEventListener('click', function () { goTo(current <= 0 ? maxIndex() : current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current >= maxIndex() ? 0 : current + 1); });

    track.addEventListener('scroll', function () {
      var closest = 0;
      var min = Infinity;
      cards.forEach(function (card, index) {
        var dist = Math.abs(card.offsetLeft - track.scrollLeft);
        if (dist < min) { min = dist; closest = index; }
      });
      current = Math.min(closest, maxIndex());
      updateDots();
    }, { passive: true });

    buildDots();
    window.addEventListener('resize', function () { buildDots(); goTo(current); });
  }

  function initAll() {
    document.querySelectorAll('[data-mc-slider]').forEach(initSlider);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
